import { oc } from '@orpc/contract';
import { idParamSchema } from '../../common/schemas/id.schemas.js';
import { runDetailSchema } from '../schemas/runs.schemas.js';
export const submitRunContract = oc
    .route({
    method: 'POST',
    path: '/runs/{id}/submit',
    tags: ['Runs'],
    summary: 'Compute the result, evaluate the validity rules and set the final run status',
    description: 'One transaction: the computed result and every rule verdict are written together with the status they justify.',
})
    .input(idParamSchema)
    .output(runDetailSchema);
//# sourceMappingURL=submit-run.contract.js.map